import utils from '../utils';
import VIEW_MODE from '../constants/viewMode';
import FORM_FACTOR from '../constants/formFactor';

var ViewModeWrapper =
/*#__PURE__*/
function () {
  function ViewModeWrapper() {
    this.setViewMode = this.setViewMode.bind(this);
    this.isSiteMode = this.isSiteMode.bind(this);
    this.isEditMode = this.isEditMode.bind(this);
    this.isPreviewMode = this.isPreviewMode.bind(this);
    this.isSEOMode = this.isSEOMode.bind(this);
    this.setFormFactor = this.setFormFactor.bind(this);
    this.isFormFactorDesktop = this.isFormFactorDesktop.bind(this);
    this.isFormFactorMobile = this.isFormFactorMobile.bind(this);
    this.isFormFactorTablet = this.isFormFactorTablet.bind(this);
    this.isFormFactorTouch = this.isFormFactorTouch.bind(this);
    this._viewMode = VIEW_MODE.SITE;
    this._formFactor = FORM_FACTOR.DESKTOP;
  }

  var _proto = ViewModeWrapper.prototype;

  _proto.setViewMode = function setViewMode(viewMode) {
    this._viewMode = viewMode;
  };

  _proto.setFormFactor = function setFormFactor(forceVal) {
    this._formFactor = forceVal;
  };

  _proto.isFormFactorMobile = function isFormFactorMobile() {
    return this._formFactor === FORM_FACTOR.MOBILE;
  };

  _proto.isFormFactorTablet = function isFormFactorTablet() {
    return this._formFactor === FORM_FACTOR.TABLET;
  };

  _proto.isFormFactorDesktop = function isFormFactorDesktop() {
    return this._formFactor === FORM_FACTOR.DESKTOP;
  };

  _proto.isFormFactorTouch = function isFormFactorTouch() {
    return this.isMobile() || this.isTablet();
  };

  _proto.isSiteMode = function isSiteMode() {
    return this._viewMode === VIEW_MODE.SITE;
  };

  _proto.isEditMode = function isEditMode() {
    return this._viewMode === VIEW_MODE.EDIT;
  };

  _proto.isPreviewMode = function isPreviewMode() {
    return this._viewMode === VIEW_MODE.PREVIEW;
  };

  _proto.isSEOMode = function isSEOMode() {
    return this._viewMode === VIEW_MODE.SEO;
  };

  return ViewModeWrapper;
}();

var viewModeWrapper = new ViewModeWrapper();
var isSiteMode = viewModeWrapper.isSiteMode;
var isEditMode = viewModeWrapper.isEditMode;
var isPreviewMode = viewModeWrapper.isPreviewMode;
var isSEOMode = viewModeWrapper.isSEOMode;
var isFormFactorMobile = viewModeWrapper.isFormFactorMobile;
var isFormFactorTablet = viewModeWrapper.isFormFactorTablet;
var isFormFactorDesktop = viewModeWrapper.isFormFactorDesktop;
var isFormFactorTouch = viewModeWrapper.isFormFactorTouch;
export { viewModeWrapper, isSiteMode, isEditMode, isPreviewMode, isSEOMode, isFormFactorMobile, isFormFactorTablet, isFormFactorDesktop, isFormFactorTouch };